import WebComponent from "../../WebComponent";
import ZVVService from "./ZVVService";
import {html} from "@isceco/widget-library2/external/lit";
import BerechtigungUtil from "../../services/BerechtigungUtil";
import ZVVDto from "./ZVVDto";
import Navigation from "../Navigation/Navigation";
import './ZVVStammdaten'
import './ZVVMitglieder'

export class ZVV extends WebComponent {

  constructor() {
    super();
    this.zvvService = new ZVVService('gp', getNavigationId())
  }

  get translationFile() {
    return './views/ZVV/i18n.json'
  }

  get subsites() {
    return {
      ZVVStammdaten: {
        render: () => html`<eko-frontend-zvv-stammdaten .zvv="${this.zvv}"></eko-frontend-zvv-stammdaten>`
      },
      ZVVMitglieder: {
        render: () => html`<eko-frontend-zvv-mitglieder .zvv="${this.zvv}"></eko-frontend-zvv-mitglieder>`
      }
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    if (getNavigationId() === undefined) {
      navigate({ to: getNavigationHash(), id: new BerechtigungUtil().getActiveProfile().zvvExtId })
      return;
    }
    Promise.resolve(
      this.zvvService.read(getNavigationId())
    ).then(json => {
      this.zvv = new ZVVDto(json)
      this.render()
    })
  }

  getTemplate() {
    const subsite = this.subsites[getNavigationHash()]
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('zvv.title')} ${this.zvv.name}"
      ></isceco-title>
      <div class="detail-flex-box">
        <div class="detail-child-left">
          <isceco-vertical-navigation .items="${this._getNavItems()}">
          </isceco-vertical-navigation>
        </div>
        <div class="detail-child-right">
          ${subsite.render()}
        </div>
      </div>
    `
  }

  _getNavItems = () => {
    return [
      {
        text: this.i18n.translate('zvv.stammdaten'),
        icon: 'table',
        url: `${Navigation.ROUTES.zvvStammdaten.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.zvvStammdaten.url]
      },
      {
        text: this.i18n.translate('zvv.mitglieder'),
        icon: 'users',
        url: `${Navigation.ROUTES.zvvMitglieder.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.zvvMitglieder.url]
      }
    ]
  }
}
customElements.define('eko-frontend-zvv', ZVV)
